"use strict";

(() => {
  var e,
    r,
    a,
    t = Object.getOwnPropertyNames,
    o = (e, r) =>
      function () {
        return e && (r = (0, e[t(e)[0]])((e = 0))), r;
      },
    s = o({
      "src/pattern.ts"() {
        e =
          " daum[ /]| deusu/| yadirectfetcher|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<![hg]m)score|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\btime/|^<|^[\\w \\.\\-\\(?:\\):]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[^ ]{50,}$|^\\d+\\b|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^active|^ad muncher|^amaya|^avsdevicesdk/|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/5\\.0\\s[a-z\\.-]+$|^mozilla/\\d\\.\\d \\(compatible;?\\)$|^mozilla/\\d\\.\\d \\w*$|^navermailapp|^netsurf|^offline|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^valid|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|^{{.*}}$|adscanner/|analyzer|archive|ask jeeves/teoma|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|evc-batch/|exaleadcloudview|feed|firephp|functionize|gomezagent|headless|httrack|hubspot marketing grader|hydra|ibisbrowser|images|infrawatch|insight|inspect|iplabel|ips-agent|java(?!;)|jsjcw_scanner|library|linkcheck|mail\\.ru/|manager|measure|neustar wpm|node|nutch|offbyone|optimize|pageburst|pagespeed|parser|perl|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|reputation|resolver|retriever|rexx;|rigor|rss\\b|scanner\\.|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|trace|transcoder|url|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|zgrab";
      },
    });
  function c(t) {
    return (
      Boolean(t) &&
      (function () {
        if (a instanceof RegExp) return a;
        try {
          a = new RegExp(e, "i");
        } catch (e) {
          a = r;
        }
        return a;
      })().test(t)
    );
  }
  var i,
    n,
    l = o({
      "src/index.ts"() {
        s(), (r = /bot|crawl|http|lighthouse|scan|search|spider/i);
      },
    });
  ((i = {
    "src/browser.ts"() {
      l(),
        "object" != typeof globalThis
          ? "object" != typeof window
            ? "object" != typeof global
              ? "object" == typeof self && (self.isBot = c)
              : (global.isBot = c)
            : (window.isBot = c)
          : (globalThis.isBot = c);
    },
  }),
    function () {
      return n || (0, i[t(i)[0]])((n = { exports: {} }).exports, n), n.exports;
    })();
})();


// Configuration object with prima prefix
var PRIMA_ROUTER_CONFIG = {
  // Domain configuration
  MAIN_DOMAIN: "www.bombayshavingcompany.com",
  ALTERNATE_DOMAIN: "shop.bombayshavingcompany.com",
  COOKIE_DOMAIN: ".bombayshavingcompany.com",
  
  // Traffic split configuration
  TRAFFIC_SPLIT_PERCENTAGE: 0, // traffic to alternate domain
  
  // Product-specific routing configuration
  SPLIT_TRIGGER_PATH: "products/full-body-trimmer-spl-edition", // Only split traffic for this product. Leave empty ("") to split traffic for ALL paths
  
  // Session configuration
  SESSION_TTL_DAYS: 90,
  
  // Router settings
  ROUTE_BOTS_TO_MAIN: true, // Route bots to main domain (Shopify)
  VERSION: 1
};

// Cookie names with prima prefix
var PRIMA_SESSION_DEST_COOKIE = "_prima_session_dest";
var PRIMA_SESSION_VERSION_COOKIE = "_prima_session_ver";

// Destinations with prima prefix
var PRIMA_DEST_MAIN = "main";
var PRIMA_DEST_ALTERNATE = "alternate";

// Shopify routes with prima prefix
var PRIMA_SHOPIFY_ROUTES = new Set([
  "/pages/cancellations-and-refunds",
  "/pages/terms-and-conditions",
  "/pages/privacy-policy",
  "/pages/returns",
  "/pages/contact-us",
  "/pages/shipping-policy",
  "/pages/loyalty-point",
  "/pages/faqs",
  "/pages/review",
  "/blogs",
  "/cdn/shop",
  "/cart.js",
  "/cart",
  "/widget",
  "/api/redirect-hit",
  "/_t/c",
  "robots.txt",
  ".mp4",
  ".js",
  ".css",
  ".json",
  ".html",
  ".png",
  ".jpeg",
  ".jpg",
  ".webp",
  "sitemap",
  "/account",
  "/checkouts",
  "/orders",
  "/pages/razorpreneur-3-0-terms-and-conditions",
  "/pages/buy-any-6-products-at-999",
  "/pages/how-to-use-video",
  "/pages/offer-wall",
  "/pages/feedback-form",
  "/pages/razorpreneur3-0",
  "/products/sensitive-shaving-foam",
  "/products/glam-up-face-razor-pack-of-3",
  "/products/grey-beard-trimmer",
  "/products/charcoal-massage-soap",
  "/collections/products-50",
  "/collections/perfumes-1",
  "/collections/test-1",
  "/products/vaccum-trimmer",
  "/products/lip-butter-10ml",
  "/products/all-rounder-2-in-1-trimmer-copy",
  "/collections/balls",
  "/collections/body",
  "/collections/beard",
  "/collections/all-trimmer",
  "/collections/skin-care-products-for-men"
]);

// ===== UTILITY FUNCTIONS WITH PRIMA PREFIX =====

function primaIsEmptyStr(value) {
  return value == null || (typeof value === "string" && value.trim().length === 0);
}

function primaSetCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "expires=" + date.toUTCString() + ";";
  }
  
  // Build secure cookie string with security attributes
  // Note: HttpOnly removed because client-side router needs to read cookies
  var cookieStr = name + "=" + encodeURIComponent(value || "") + "; " +
                  expires +
                  " domain=" + PRIMA_ROUTER_CONFIG.COOKIE_DOMAIN +
                  "; path=/;" +
                  " Secure;" +                    // Only transmitted over HTTPS
                  " SameSite=Strict;";           // Prevent cross-site request inclusion
  
  document.cookie = cookieStr;
}

function primaGetCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0)
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

function primaCheckIfMobile(userAgent) {
  return (
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(userAgent) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(userAgent)
  );
}

function primaIsShopifyRoute(path) {
  if (PRIMA_SHOPIFY_ROUTES.has(path)) {
    return true;
  }
  
  var pathsArr = Array.from(PRIMA_SHOPIFY_ROUTES);
  for (let i = 0; i < pathsArr.length; i++) {
    var pathItem = pathsArr[i];
    if (path.startsWith(pathItem) || path.indexOf(pathItem) !== -1) {
      return true;
    }
  }
  return false;
}

// Function to check if current URL should trigger traffic splitting
function primaShouldSplitTraffic(currentPath, currentUrl) {
  // If SPLIT_TRIGGER_PATH is empty, split traffic for all paths
  if (primaIsEmptyStr(PRIMA_ROUTER_CONFIG.SPLIT_TRIGGER_PATH)) {
    return true; // Split traffic for all paths when trigger path is empty
  }
  
  // Check if the URL contains the specific product path
  return currentUrl.indexOf(PRIMA_ROUTER_CONFIG.SPLIT_TRIGGER_PATH) !== -1 || 
         currentPath.indexOf(PRIMA_ROUTER_CONFIG.SPLIT_TRIGGER_PATH) !== -1;
}

function primaGenerateRedirectUrl(destination) {
  var currentUrl = new URL(window.location.href);
  var targetDomain = destination === PRIMA_DEST_ALTERNATE ? PRIMA_ROUTER_CONFIG.ALTERNATE_DOMAIN : PRIMA_ROUTER_CONFIG.MAIN_DOMAIN;
  
  // Replace the domain while keeping everything else the same
  var redirectUrl = currentUrl.protocol + "//" + targetDomain + currentUrl.pathname + currentUrl.search + currentUrl.hash;
  return redirectUrl;
}

function primaGetSessionDestination() {
  var sessionDest = primaGetCookie(PRIMA_SESSION_DEST_COOKIE);
  var sessionVersion = primaGetCookie(PRIMA_SESSION_VERSION_COOKIE);
  
  // Check if session is valid and current version
  if (!primaIsEmptyStr(sessionDest) && parseInt(sessionVersion) === PRIMA_ROUTER_CONFIG.VERSION) {
    return sessionDest;
  }
  
  return null;
}

function primaSetSessionDestination(destination) {
  primaSetCookie(PRIMA_SESSION_DEST_COOKIE, destination, PRIMA_ROUTER_CONFIG.SESSION_TTL_DAYS);
  primaSetCookie(PRIMA_SESSION_VERSION_COOKIE, PRIMA_ROUTER_CONFIG.VERSION.toString(), PRIMA_ROUTER_CONFIG.SESSION_TTL_DAYS);
}

// ===== MAIN ROUTER LOGIC =====

try {
  console.log("[PRIMATHON_ROUTER] Starting router logic");
  
  var primaCurrentPath = window.location.pathname.replace(/\/$/, "").toLowerCase();
  var primaCurrentUrl = window.location.href.toLowerCase();
  var primaUserAgent = window.navigator.userAgent;
  var primaIsMobile = primaCheckIfMobile(primaUserAgent);
  var primaIsBot = window.isBot && window.isBot(primaUserAgent);
  
  console.log("[PRIMATHON_ROUTER] Path:", primaCurrentPath, "Mobile:", primaIsMobile, "Bot:", primaIsBot);
  
  // Check if this is a Shopify route that should always stay on main domain
  if (primaIsShopifyRoute(primaCurrentPath)) {
    console.log("[PRIMATHON_ROUTER] Shopify route detected, staying on main domain");
    // Don't redirect, stay on current domain
  } else if (primaIsBot && PRIMA_ROUTER_CONFIG.ROUTE_BOTS_TO_MAIN) {
    // Route bots to main domain (Shopify) if configured
    console.log("[PRIMATHON_ROUTER] Bot detected, routing to main domain");
    primaSetSessionDestination(PRIMA_DEST_MAIN);
    // Don't redirect bots, let them stay on main domain
  } else {
  
    // **FIXED** - Check existing session destination FIRST for session stickiness
    var primaSessionDestination = primaGetSessionDestination();
    
    if (primaSessionDestination) {
      // **SESSION STICKINESS** - User has existing session, honor it regardless of current path
      console.log("[PRIMATHON_ROUTER] Existing session found, maintaining stickiness to:", primaSessionDestination);
      
      // Check if we need to redirect based on session destination
      var primaCurrentDomain = window.location.hostname;
      var primaShouldRedirect = false;
      var primaRedirectUrl = "";
      
      if (primaSessionDestination === PRIMA_DEST_ALTERNATE && primaCurrentDomain === PRIMA_ROUTER_CONFIG.MAIN_DOMAIN) {
        // Should be on alternate domain but currently on main domain
        primaShouldRedirect = true;
        primaRedirectUrl = primaGenerateRedirectUrl(PRIMA_DEST_ALTERNATE);
      } else if (primaSessionDestination === PRIMA_DEST_MAIN && primaCurrentDomain === PRIMA_ROUTER_CONFIG.ALTERNATE_DOMAIN) {
        // Should be on main domain but currently on alternate domain
        primaShouldRedirect = true;
        primaRedirectUrl = primaGenerateRedirectUrl(PRIMA_DEST_MAIN);
      }
      
      if (primaShouldRedirect) {
        console.log("[PRIMATHON_ROUTER] Session stickiness redirect to:", primaRedirectUrl);
        window.location.replace(primaRedirectUrl);
      } else {
        console.log("[PRIMATHON_ROUTER] Session stickiness - already on correct domain");
      }
      
    } else {
      // **NEW SESSION** - No existing session, check if current URL should trigger traffic splitting
      var primaShouldSplit = primaShouldSplitTraffic(primaCurrentPath, primaCurrentUrl);
      var triggerPathStatus = primaIsEmptyStr(PRIMA_ROUTER_CONFIG.SPLIT_TRIGGER_PATH) ? "ALL PATHS" : PRIMA_ROUTER_CONFIG.SPLIT_TRIGGER_PATH;
      console.log("[PRIMATHON_ROUTER] New session - Should split traffic:", primaShouldSplit, "for URL:", primaCurrentUrl, "| Trigger:", triggerPathStatus);
      
      if (!primaShouldSplit) {
        // If URL doesn't match trigger criteria, route to main domain by default
        console.log("[PRIMATHON_ROUTER] New session - URL doesn't match trigger criteria, routing to main domain");
        primaSetSessionDestination(PRIMA_DEST_MAIN);
        
        // Check if we need to redirect to main domain
        var primaCurrentDomain = window.location.hostname;
        if (primaCurrentDomain === PRIMA_ROUTER_CONFIG.ALTERNATE_DOMAIN) {
          var primaRedirectUrl = primaGenerateRedirectUrl(PRIMA_DEST_MAIN);
          console.log("[PRIMATHON_ROUTER] New session redirect from alternate to main domain:", primaRedirectUrl);
          window.location.replace(primaRedirectUrl);
        } else {
          console.log("[PRIMATHON_ROUTER] New session - already on main domain");
        }
      } else {
        // New session on trigger path - determine destination based on traffic split
        var splitReason = primaIsEmptyStr(PRIMA_ROUTER_CONFIG.SPLIT_TRIGGER_PATH) ? "all paths (no trigger specified)" : "trigger path matched";
        console.log("[PRIMATHON_ROUTER] New session - Traffic splitting enabled:", splitReason);
        
        var primaRandom = Math.random() * 100;
        var primaFinalDestination;
        
        if (primaRandom < PRIMA_ROUTER_CONFIG.TRAFFIC_SPLIT_PERCENTAGE) {
          primaFinalDestination = PRIMA_DEST_ALTERNATE;
        } else {
          primaFinalDestination = PRIMA_DEST_MAIN;
        }
        
        // Set session destination for consistency
        primaSetSessionDestination(primaFinalDestination);
        console.log("[PRIMATHON_ROUTER] New session assigned destination:", primaFinalDestination, "Random:", primaRandom);
        
        // Check if we need to redirect
        var primaCurrentDomain = window.location.hostname;
        var primaShouldRedirect = false;
        var primaRedirectUrl = "";
        
        if (primaFinalDestination === PRIMA_DEST_ALTERNATE && primaCurrentDomain === PRIMA_ROUTER_CONFIG.MAIN_DOMAIN) {
          // Should be on alternate domain but currently on main domain
          primaShouldRedirect = true;
          primaRedirectUrl = primaGenerateRedirectUrl(PRIMA_DEST_ALTERNATE);
        } else if (primaFinalDestination === PRIMA_DEST_MAIN && primaCurrentDomain === PRIMA_ROUTER_CONFIG.ALTERNATE_DOMAIN) {
          // Should be on main domain but currently on alternate domain
          primaShouldRedirect = true;
          primaRedirectUrl = primaGenerateRedirectUrl(PRIMA_DEST_MAIN);
        }
        
        if (primaShouldRedirect) {
          console.log("[PRIMATHON_ROUTER] New session redirect to:", primaRedirectUrl);
          window.location.replace(primaRedirectUrl);
        } else {
          console.log("[PRIMATHON_ROUTER] New session - no redirect needed");
        }
      }
    }
  }
  
} catch (error) {
  console.error("[PRIMATHON_ROUTER] Error:", error);
  // On error, don't redirect - stay on current domain
}

console.log("[PRIMATHON_ROUTER] Router execution completed");